module.exports = __webpack_public_path__ + "static/media/LukeSkywalker.158fdc6e.jpg";